import React from 'react';
import { Card } from '@dopomogai/ui';

export function MyQuotesHeader() {
  return (
    <Card noHoverEffect>
      <div className="p-6 md:p-8">
        <h1 className="text-2xl md:text-3xl font-extrabold text-slate-900">My Quotes</h1>
        <p className="text-slate-600 mt-2">
          Review your AI agent quotes. Pay pending quotes, or view details and receipts for completed ones.
        </p>
      </div>
    </Card>
  );
}
